import { useTranslations } from 'next-intl'

import { useFormatCurrency, useFormatDate } from '@/shared/lib'

export type Props = {
  roomName: string
  startDate: string
  endDate: string
  finalPayFee: number
}

const DATE_FORMAT = 'yyyy년 MM월 dd일'

export const ContractInformation = ({
  roomName,
  startDate,
  endDate,
  finalPayFee,
}: Props) => {
  const t = useTranslations()
  const { formatDate } = useFormatDate()
  const { formatCurrency } = useFormatCurrency()

  const formattedStartDate = formatDate({
    date: startDate,
    format: DATE_FORMAT,
  })
  const formattedEndDate = formatDate({
    date: endDate,
    format: DATE_FORMAT,
  })

  return (
    <div className="space-y-3 p-6 pt-0">
      <h3 className="typo-body1 text-start font-semibold text-black">
        {t('card_payment.contract_info.title')}
      </h3>
      <div className="space-y-4">
        <div className="flex flex-col items-start gap-0.5">
          <p className="typo-label1 font-normal text-gray-500">
            {t('card_payment.contract_info.label.room_name')}
          </p>
          <p className="typo-label1 font-medium text-gray-900">{roomName}</p>
        </div>
        <div className="flex flex-col items-start gap-0.5">
          <p className="typo-label1 font-normal text-gray-500">
            {t('card_payment.contract_info.label.lease_period')}
          </p>
          <p className="typo-label1 font-medium text-gray-900">
            {t.rich('card_payment.contract_info.duration', {
              startDate: formattedStartDate,
              endDate: formattedEndDate,
              strong: chunks => (
                <span className="text-purple-500">{chunks}</span>
              ),
            })}
          </p>
        </div>
        <div className="flex flex-col items-start gap-0.5">
          <p className="typo-label1 font-normal text-gray-500">
            {t('card_payment.contract_info.label.payment_amount')}
          </p>
          <p className="typo-body1 font-bold text-gray-900">
            {formatCurrency(finalPayFee)}
          </p>
        </div>
      </div>
    </div>
  )
}
